module.exports = __webpack_public_path__ + "static/power_of_adaptive_training_mobile-a619438e13e62ac61cd2724baa8b9ae4.jpg";